import { makeStyles } from "@material-ui/core";
import { colors } from "../../../theme/variables";

export const useStyles = makeStyles({
  name: {
    width: "50%",
  },
  submitButton: {
    float: "right",
  },
  toolbar: {
    backgroundColor: colors.gray14,
  },
  workflowName: {
    fontWeight: "bold",
  },
  main: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflow: "auto",
    // backgroundColor: "#fff",
    // height: "100vh",
  },
  fields: {
    width: "100%",
    height: "100%",

    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflowX: "hidden",
    overflowY: "auto",
    gap: 15,
  },
  formLabel: {
    fontSize: "13px",
    fontWeight: 600,
  },
  iconContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "30px",
    height: "20px",
    cursor: "pointer",
    color: colors.red07,
  },
  icon: { cursor: "pointer" },
  switchContainer: { marginLeft: 0 },
  switchRoot: { marginRight: "1rem" },
  rootBox: {
    borderColor: "rgba(128, 128, 128, 0.2)",
    borderStyle: "solid",
    borderWidth: "1px",
    borderRadius: "4px",
    backgroundColor: "rgb(255, 255, 255)",
  },
  monaco: {
    padding: 10,
    width: "100%",
    borderColor: "rgba(128, 128, 128, 0.2)",
    borderStyle: "solid",
    borderWidth: 1,
    borderRadius: 4,
    backgroundColor: "rgb(255, 255, 255)",
    "&:focus-within": {
      margin: -2,
      borderColor: "rgb(73, 105, 228)",
      borderStyle: "solid",
      borderWidth: 2,
    },
  },
  // DoWhile specific styles
  header: {
    display: "flex",
    marginBottom: "1rem",
  },
  redIconContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "30px",
    height: "20px",
    cursor: "pointer",
    color: colors.red07,
  },
  // Button styles from useStylesJoinTask
  btn: {
    display: "inline-flex",
    "-webkit-box-align": "center",
    alignItems: "center",
    "-webkit-box-pack": "center",
    justifyContent: "center",
    position: "relative",
    boxSizing: "border-box",
    "-webkit-tap-highlight-color": "transparent",
    outline: "0px",
    margin: "0px",
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    appearance: "none",
    textDecoration: "none",
    fontFamily: `Lexend, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    lineHeight: "1.75",
    minWidth: "64px",
    textTransform: "none",
    borderRadius: "6px",
    transition: "none 0s ease 0s",
    fontWeight: "500",
    boxShadow: "none",
    padding: "8px 12px",
    minHeight: "28px",
    height: "28px",
    fontSize: "12px",
  },
  btnDisabled: {
    color: "rgb(175, 175, 175) !important",
    backgroundColor: "rgb(243, 243, 243) !important",
    borderColor: "rgb(175, 175, 175)",
  },
  btnBlue: {
    color: "rgb(255, 255, 255)",
    backgroundColor: "rgb(25, 118, 210)",
    border: "1px solid rgb(25, 118, 210)",
  },
  // Shared form field styles for 32px height
  inputField: {
    "& .MuiOutlinedInput-root": {
      height: "35px !important",
    },
    "& .MuiOutlinedInput-input": {
      padding: "6px 14px !important",
      height: "20px !important",
    },
  },
  dropdownField: {
    "& .MuiAutocomplete-input": {
      height: "23px !important",
      padding: "6px 14px !important",
      display: "flex !important",
      alignItems: "center !important",
    },
  },
});
